<div class="is-flex is-space-between">
  <section class="is-flex container">
    <app-text class="text-header text-14 is-family-semiBold"> {{'common-app.__HEATING_REPORTS' | AsyncLang | async}} </app-text>
  </section>
  
  <ng-container *ngIf="reportThermostats$ | async as reportDevices">
    <app-cp-reports-device-selector *ngIf="reportDevices.length > 1"></app-cp-reports-device-selector>
  </ng-container>
</div>

<ng-container *ngIf="report$ | async as report">
  <section class="error text-14 is-family-semiBold" *ngIf="report.problem_duration !== undefined">
    <app-text > {{'bilan-energy.__REPORT_ERROR_DETECTED' | AsyncLang | async }}</app-text>
  </section>
  <section class="error text-14 is-family-semiBold" *ngIf="report.mf !== undefined">
    <app-text > {{'bilan-energy.__REPORT_MISSING_DATA' | AsyncLang | async }}</app-text>
  </section>
  <section class="no-report text-14 is-family-semiBold" *ngIf="report.error?.code === 31">
    {{'bilan-energy.__REPORT_NOT_COMPUTED_YET' | AsyncLang | async}}
  </section>
</ng-container>
